import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/recepcao`

    return {
        create(filaId = null) {
            if (filaId) {
                return repository.get(`${baseUrl}/create/${filaId}`)
            } else {
                return repository.get(`${baseUrl}/create`)
            }
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        unidadePaciente(pacienteId) {
            return repository.get(`${baseUrl}/unidade-paciente/${pacienteId}`)
        },
        paciente: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            },
        }
    }
}